import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import './Chat.css';
import MediaQuery from 'react-responsive';
import { colors } from 'helpers/ColorHelper';

import ConversationList from './ConversationList.js';
import ComposeMessage from './ComposeMessage.js';
import Conversation from './Conversation.js';
import ConversationDialog from './ConversationDialog.js';
import { ChatTenantInformation } from './ChatTenantInformation';

import * as chatActions from 'actions/chatActions';
import constants from 'helpers/constants';

const MESSAGES_POLL_INTERVAL = 6000;
const CONVERSATIONS_POLL_INTERVAL = 9000;

const mapStoreToProps = store => {
  return {
    landlordDetails: store.chat.landlordDetails,
    messages: store.chat.messages,
    conversations: store.chat.conversations,
    activeConversation: store.chat.activeConversation,
    lastMessageTime: store.chat.lastMessageTime,
    lastConversationTime: store.chat.lastConversationTime,
    loadingConversations: store.chat.loadingConversations,
    loadingMostRecentMessages: store.chat.loadingMostRecentMessages,
    loadingMoreMessages: store.chat.loadingMoreMessages,
    showPage: store.authentication.showPage,
    userTypes: store.userTypes,
    properties: store.chat.properties,
  };
};

const StyledBody = styled.div`
  height: calc(100% - 53px);
  margin-top: 53px;
`;

const StyledBodyInner = styled.div`
  height: 100%;
  display: flex;
  @media (max-width: 750px) {
    position: fixed;
    bottom: 0;
    height: calc(100% - 105px);
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
`;

const StyledConversationListContainer = styled.div`
  min-width: 23rem;
  background-color: #fff;
  z-index: 2;
  height: 100%;
`;

const StyledMainContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.LIGHT_GRAY};
`;

class Chat extends Component {
  pollMessages = () => {
    return setInterval(() => {
      if (this.props.lastMessageTime && !this.props.loadingMessages)
        this.props.updateConversation(
          this.props.activeConversation.id,
          this.props.lastMessageTime,
          true
        );
    }, MESSAGES_POLL_INTERVAL);
  };

  pollConversations = () => {
    return setInterval(() => {
      if (this.props.lastConversationTime && this.props.conversations.length > 0)
        this.props.updateConversations(this.props.lastConversationTime);
    }, CONVERSATIONS_POLL_INTERVAL);
  };

  componentDidMount() {
    const userType = this.getUserType();
    if (userType === constants.userTypes.AGENT) {
      this.props.getProperties();
    } else if (userType === constants.userTypes.LEAD) {
      this.props.getLandlordDetails();
    }

    this.props.initalizeChat().then(() => {
      this.pollMessages = this.pollMessages();
      this.pollConversations = this.pollConversations();
    });
  }

  componentWillUnmount() {
    clearInterval(this.pollMessages);
    clearInterval(this.pollConversations);
    this.props.receiveMessages([]);
  }

  getUserType = () => {
    if (!this.props.userTypes.loginAuth) {
      return constants.userTypes.LEAD;
    } else if (this.props.userTypes.loginAuth === 'landlord') {
      return constants.userTypes.AGENT;
    } else {
      return this.props.userTypes.loginAuth;
    }
  };

  markAsRead = async conversationId => {
    await this.props.markMessagesAsRead(conversationId);
    this.props.updateConversations(this.props.lastConversationTime);
    this.props.updateConversation(
      this.props.activeConversation.id,
      this.props.lastMessageTime,
      true
    );
  };

  unreadMessageCount = (conversations, activeConversation) => {
    if (!conversations) return;
    if (!activeConversation) return;

    const updatedActiveConversation = conversations.filter(
      conversation => conversation.id === activeConversation.id
    )[0];
    if (!updatedActiveConversation) return;

    return updatedActiveConversation.landlord_unread_messages;
  };

  render() {
    const {
      conversations,
      fetchConversations,
      activeConversation,
      setActiveConversation,
      properties,
      getProperties,
      createPropertyNotification,
      messages,
      loadingConversations,
    } = this.props;
    const userType = this.getUserType();

    return (
      <StyledBody className={"fs-exclude"}>
        {this.props.showPage && (
          <StyledBodyInner>
            <MediaQuery query="(max-device-width: 750px)">
              <ConversationDialog
                userType={userType}
                conversations={conversations}
                fetchConversations={fetchConversations}
                activeConversation={activeConversation}
                setActiveConversation={setActiveConversation}
                properties={properties}
                getProperties={getProperties}
                createPropertyNotification={createPropertyNotification}
              />
            </MediaQuery>

            <MediaQuery query="(min-device-width: 750px)">
              <StyledConversationListContainer>
                <ConversationList
                  userType={userType}
                  conversations={conversations}
                  fetchConversations={fetchConversations}
                  activeConversation={activeConversation}
                  setActiveConversation={setActiveConversation}
                  properties={properties}
                  createPropertyNotification={createPropertyNotification}
                  loadingConversations={loadingConversations}
                />
              </StyledConversationListContainer>
            </MediaQuery>

            <StyledMainContainer>
              {activeConversation && <ChatTenantInformation conversation={activeConversation} />}
              <Conversation
                userType={userType}
                messages={messages}
                loadingMostRecentMessages={this.props.loadingMostRecentMessages}
                conversation={activeConversation}
                fetchMessages={this.props.fetchMessages}
                unreadMessageCount={this.unreadMessageCount(conversations, activeConversation)}
                markMessagesAsRead={this.markAsRead}
                isLandlord
              />
              <ComposeMessage
                sendMessage={this.props.sendMessage}
                activeConversation={activeConversation}
              />
            </StyledMainContainer>
          </StyledBodyInner>
        )}
      </StyledBody>
    );
  }
}

export default connect(mapStoreToProps, chatActions)(Chat);
